module.exports = __webpack_public_path__ + "img/image-lazy-loading.f65f2720.gif";